import { render, staticRenderFns } from "./OrderBy.vue.html?vue&type=template&id=15c7fa43&"
import script from "./OrderBy.component.js?vue&type=script&lang=vueJs&"
export * from "./OrderBy.component.js?vue&type=script&lang=vueJs&"
import style0 from "./OrderBy.scss?vue&type=style&index=0&prod&lang=vueScss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports